import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';

import corner from '../assets/corner.png';
import side1 from '../assets/side_1.png';
import side2 from '../assets/side_2.png';
import up1 from '../assets/up_1.png';
import up2 from '../assets/up_2.png';
import up3 from '../assets/up_3.png';
import bg from '../assets/wedding-bg.jpg';

import './LandingPage.css';

const MIN_DISPLAY_TIME = 2000;
const FADE_DURATION = 1200;

const assets = [
  corner,
  side1,
  side2,
  up1,
  up2,
  up3,
  bg,
];

const preloadImages = (sources) =>
  Promise.all(
    sources.map(
      (src) =>
        new Promise((resolve) => {
          const img = new Image();
          img.src = src;
          img.onload = resolve;
          img.onerror = resolve;
        })
    )
  );

const LandingPage = () => {
  const navigate = useNavigate();
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const start = Date.now();

    const run = async () => {
      try {
        // 1️⃣ Run everything in parallel
        const [userCheck] = await Promise.all([
          api.get('/api/user/exists'),
          preloadImages(assets),
        ]);

        // 2️⃣ Enforce minimum display time
        const elapsed = Date.now() - start;
        const remaining = Math.max(MIN_DISPLAY_TIME - elapsed, 0);

        setTimeout(() => {
          setFadeOut(true);

          setTimeout(() => {
            navigate(userCheck.data.exists ? '/home' : '/admin-setup');
          }, FADE_DURATION);
        }, remaining);

      } catch (err) {
        console.error('Landing error:', err);
      }
    };

    run();
  }, [navigate]);

  return (
    <div className={`landing-container ${fadeOut ? 'fade-out' : ''}`}>
      <div className="loader-wrapper">
        <img src={bg} className="loader-image" alt="Loading" />
        <div className="loader-text">Welcome</div>
      </div>
    </div>
  );
};

export default LandingPage;
